import { AUTO, Game, Scale, type Types } from 'phaser';
import type { BalanceArenaConfig } from '../domain/balanceLevels';
import { BalanceArenaScene } from './BalanceArenaScene';

export function startBalanceArenaGame(parent: string, gameId: string, arenaConfig: BalanceArenaConfig, restartEnabled = true): Game {
  const config: Types.Core.GameConfig = {
    type: AUTO, width: 1280, height: 720, parent, backgroundColor: '#6fc4e5',
    scale: { mode: Scale.ENVELOP, autoCenter: Scale.CENTER_BOTH },
    scene: [new BalanceArenaScene(arenaConfig, gameId, restartEnabled)],
  };
  return new Game(config);
}
